import { $authHost } from "./index";

export const getFile = async (id) => {
  const { data } = await $authHost.get("/api/uploads/"+ id);

  return data;
};

export const deleteFile = async (id) => {
  const { data } = await $authHost.delete("/api/uploads/"+ id);

  return data;
};